import { render, staticRenderFns } from "./AbsenteeBid.vue?vue&type=template&id=6b9a54d2"
import script from "./AbsenteeBid.vue?vue&type=script&lang=js"
export * from "./AbsenteeBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports